import { Box, LinearProgress } from '@mui/material';
import React from 'react';
import { ApprovalData, DocumentAgentData } from '../../types';

type DocuSignURL = {
  url: DocumentAgentData['SignerUrl'] | ApprovalData['ApproverURL'];
};

export function ContractDocuSign({ url }: DocuSignURL) {
  // State
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
  }, [url]);

  return (
    <Box
      sx={{ minHeight: 0, flex: 1, display: 'flex', flexDirection: 'column' }}
    >
      {isLoading && <LinearProgress sx={{ backgroundColor: '#4F46E5' }} />}

      <iframe
        title="Contract for Carrier"
        src={url || ''}
        style={{ flex: 1, width: '100%', height: '100%', border: 'none' }}
        onLoad={() => setIsLoading(false)}
      />
    </Box>
  );
}
